// Total em Dívida = soma do valor corrigido das linhas que compõem a apuração.
// O filtro é redundante com `dadosParaIndicadores` de propósito: protege o
// denominador caso um chamador futuro passe a lista integral do relatório.
export const calcularTotalDivida = itens =>
  itens
    .filter(item => item.compoe_apuracao)
    .reduce((acumulado, item) => acumulado + item.valor_corrigido, 0);
